export default __webpack_public_path__ + "static/media/thumbnail-8.28c5bfd9.jpg";